window.discoveryDesignAfterCallBack = function(data) {
  const findData = data.find((x) => x.title == 'Body Panels - Genuine Buddy')
 if(findData){
   let dcDesignItem = '';
    dcDesignItem += '<figure>';
      dcDesignItem += '<a href="/pages/genuine-buddy-body-panels?tags=Genuine-Buddy-Body-Panels&page=1" class=""><img src="'+findData.image.url+'" alt="'+findData.title+'"/></a>';
    dcDesignItem += '</figure>';
    dcDesignItem += '<div class="dc_design_item_contain">';
      dcDesignItem += '<h6><a href="/pages/genuine-buddy-body-panels?tags=Genuine-Buddy-Body-Panels&page=1">'+findData.title+'</a></h6>';
    dcDesignItem += '</div>';
    document.querySelector('#dc_design_item_' + findData.id).innerHTML = dcDesignItem;
    }
}

window.discoveryDesignDetailAfterCallBack = function(products) {
  (products || []).map((data,index) =>{
    if(data?.tags){
      const dataTags = data.tags.split(', ');
      const cloneProperty = {};
      (dataTags || []).map((x,i)=>{
        if(x === 'Genuine Scooters PARTS'){
          cloneProperty['_Genuine_Scooters_PARTS'] = true;
        } 
      })
      document.querySelectorAll('[data-product_id="'+data.id+'"]').forEach(function(this_product){
        this_product.setAttribute("data-property", JSON.stringify(cloneProperty));
      });
    }
  })
}
window.discoveryProductDiagramCallBack = function(products) {
  console.log('products:',products.length);
  if(products.length == 0 & document.querySelectorAll('.pdp_diamrans_list_wrap').length > 0){
    document.querySelector('.pdp_diamrans_list_wrap').style.display = 'none'
  }
}